import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import Home from "./components/Common/Home";
import NoOrangesoftwareDomain from "./components/Common/NoOrangesoftwareDomain";
import AdminLayout from "./layouts/Admin";
import UserLayout from "./layouts/User";
import AuthGuard from "./components/HOCs/authGuard";

const routes = [
    {
    path: '/',
    exact: true,
    component: () => <Redirect to="/Home" />
  },
  {
    path: '/admin',
    component: AuthGuard(AdminLayout),
    data:{roles:['Admin']},
    routes: [
      {
        path: '/admin/dashboard',
        exact: true,
        component: lazy(() => import('./components/Admin/Dashboard'))
      },
      {
        path: '/admin/server',
        exact: true,
        component: lazy(() => import('./components/Admin/Server/Server'))
      },
      {
        path: '/admin/user',
        exact: true,
        component: lazy(() => import('./components/Admin/User/User'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
    },
    {
        path: '/app',
        component: AuthGuard(UserLayout),
        data:{roles:['User']},
        routes: [
          {
            path: '/app/dashboard',
            exact: true,
            component: lazy(() => import('./components/User/Dashboard'))
          },
          {
            component: () => <Redirect to="/errors/error-404" />
          }
        ]
      },
  {
    route: '*',
    component: Home,
    routes: [
      {
        path: '/NoOrangesoftwareDomain',
        exact: true,
        component: NoOrangesoftwareDomain
      },
    ]
  }
];

export default routes;
